import { serviceConfig } from '@h5-journey/config'
import { AxiosRequestConfig } from 'axios'
import { IRequestConfig, request } from './request'

export { default as axiosInstance } from './axios'
export { setRequestFrom } from './axios'
export { isHasToken } from './request'

interface GetParams extends AxiosRequestConfig {
  // 非axios相关配置
  requestConfig?: IRequestConfig
}

// 发送get请求
export function get(url: string, data: any, { requestConfig, ...params }: GetParams = {}) {
  return request(
    {
      url,
      method: 'get',
      params: data,
      ...params
    },
    {
      prefix: serviceConfig.mobServer as string,
      ...requestConfig
    }
  )
}

interface IPostConfig extends AxiosRequestConfig {
  isApp?: boolean
  yundianToken?: string
  // 非axios配置
  requestConfig?: IRequestConfig
}

// 发送post请求
export function post(
  url: string,
  data: any,
  { isApp, yundianToken, requestConfig, ...params }: IPostConfig = {}
) {
  return request(
    {
      url,
      method: 'post',
      data: data,
      ...params,
      headers: {
        ...params.headers,
        ...(isApp && {
          version: '5.0.1',
          os: 'android'
        }),
        ...(yundianToken && {
          token: yundianToken
        })
      }
    },
    {
      prefix: serviceConfig.mobServer as string,
      ...requestConfig
    }
  )
}
